import { Helmet } from 'react-helmet-async';
import { config } from '../lib/config';

type Props = { title: string; description: string; path?: string; noIndex?: boolean; schema?: Record<string, unknown> };

export function Seo({ title, description, path = '/', noIndex, schema }: Props) {
  const canonical = `${config.marketingUrl}${path === '/' ? '' : path}`;
  const fullTitle = title.includes('CoopCore') ? title : `${title} | CoopCore`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="CoopCore" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={`${config.marketingUrl}/coopcore-logo.png`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {noIndex ? <meta name="robots" content="noindex,nofollow" /> : null}
      {schema ? <script type="application/ld+json">{JSON.stringify(schema)}</script> : null}
    </Helmet>
  );
}
